import { StructuredOnboardingFlow } from "@/components/onboarding/structured-onboarding-flow";

const Onboarding = () => {
  return <StructuredOnboardingFlow />;
};

export default Onboarding;